module.exports = __webpack_public_path__ + "static/media/Login_Roses_1920.dbb21fba.jpg";